import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { Hashtag } from './usePaginateHashtags'

interface GetHashtagByIdResponse {
  hashtag: Hashtag
}

const fetchHashtagById = async (id: string): Promise<Hashtag> => {
  const { data } = await api.get<GetHashtagByIdResponse>(`/hashtags/${id}`)
  return data.hashtag
}

export const useGetHashtagById = (id: string) => {
  return useQuery<Hashtag>({
    queryKey: ['hashtag', id],
    queryFn: () => fetchHashtagById(id),
    enabled: !!id,
  })
}

